module.exports = __webpack_public_path__ + "static/MH-a52e8964531955aa11d8c7f41d352109.jpg";